import { graphql, useStaticQuery } from 'gatsby';

export const usePageContexts = () => {
    const result = useStaticQuery(graphql`
        query allPageContext {
          allSitePage {
            nodes {
              path
              pageContext
            }
          }
        }
    `);

    return result;
}